export const REFERRAL_LINKS_FETCH = 'REFERRAL_LINKS_FETCH';
export const REFERRAL_LINKS_IS_FETCING = 'REFERRAL_LINKS_IS_FETCHING';
export const REFERRAL_LINKS_API = `referralLinks`;
export const REFERRAL_LINK_EDIT = 'REFERRAL_LINK_EDIT';
export const REFERRAL_LINK_SAVE = 'REFERRAL_LINK_SAVE';
export const REFERRAL_LINK_FILTER = 'REFERRAL_LINK_FILTER';


// WEBPACK FOOTER //
// ./src/constants/referralLinks.js